import types from '../types';

const traderInfo = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_TRADER_INFO_START:
      return { ...state, loading: true };

    case types.GET_TRADER_INFO_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.UPDATE_TRADER_INFO_SUCCESS:
      return { ...state, data: { ...state.data, is_active: payload.is_active } };

    case types.GET_TRADER_INFO_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default traderInfo;
